/* OBB cart line controller. Registers window.obbUpdateSellingPlan for
   subscription toggle/cadence change AJAX. Phase 1 launch — Phase 2
   cart modernization may expand this into a more comprehensive cart
   controller. */
(function () {
  if (window.obbUpdateSellingPlan) return;

  window.obbUpdateSellingPlan = function (lineKey, lineIndex, lineQuantity, sellingPlanIdOrEmpty) {
    var payload = {
      line: lineIndex,
      quantity: lineQuantity,
      selling_plan: sellingPlanIdOrEmpty || null
    };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('cart/change.js returned ' + response.status);
        }
        return response.json();
      })
      .then(function () {
        if (window.Alpine && Alpine.store && Alpine.store('xCartHelper') && typeof Alpine.store('xCartHelper').reRenderSections === 'function') {
          Alpine.store('xCartHelper').reRenderSections();
        } else {
          console.warn('OBB: xCartHelper unavailable, falling back to reload');
          window.location.reload();
        }
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      })
      .catch(function (error) {
        console.error('OBB subscription update failed:', error);
      });
  };
})();

/* Runtime monkey-patch for Eurus theme.js:849 xCartHelper.reRenderSections
   array-coercion bug. The else-branch (≤4 sections) interpolates the raw
   array of section objects into the URL, producing
   '?sections=[object Object],...' and yielding a malformed Shopify
   response of {"[object Object]": null}. Wrapper short-circuits to
   orig.call when sections is already provided, intercepts only the
   broken-else-branch path (no-arg invocations), and rebuilds the URL
   using comma-joined section IDs. See docs/theme-patches.md. */
document.addEventListener('alpine:init', function () {
  // theme.js registers xCartHelper inside its own alpine:init handler;
  // ordering between handlers isn't guaranteed, so defer with setTimeout(0).
  setTimeout(function () {
    if (!window.Alpine || !Alpine.store) return;
    var helper = Alpine.store('xCartHelper');
    if (!helper || typeof helper.reRenderSections !== 'function') {
      console.warn('OBB: xCartHelper not found; reRenderSections wrapper not installed.');
      return;
    }
    if (helper.reRenderSections.__obbPatched) {
      // Idempotency guard against double-init (HMR, navigation, etc.).
      return;
    }
    var orig = helper.reRenderSections;
    helper.reRenderSections = function (sections) {
      // Pass-through when caller supplied sections (e.g., theme.js paths
      // that POST to cart.js with a sections list and forward the response).
      // Only the no-arg path triggered the broken else-branch.
      if (sections) {
        return orig.call(this, sections);
      }
      var self = this;
      var ids = this.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      return fetch(window.location.pathname + '?sections=' + ids)
        .then(function (res) { return res.json(); })
        .then(function (resSection) { return orig.call(self, resSection); });
    };
    helper.reRenderSections.__obbPatched = true;
  }, 0);
});

/* Phase 2B-Beta: cart drawer upsell add-to-cart delegation handler.
   Wires the obb-cart-upsell__add-btn buttons in mini-card-product.liquid
   to a direct /cart/add.js POST that bypasses the QuickView store
   indirection (gated off via aside-group.json:403). Click is delegated
   on document so cart-drawer AJAX re-renders survive without re-binding.
   See docs/phase-2b-beta-scope.md and docs/theme-patches.md section 5. */
(function () {
  if (window.obbCartUpsellAdd) return;

  window.obbCartUpsellAdd = async function (variantId, buttonEl) {
    var xCartHelper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    if (!xCartHelper) {
      console.warn('OBB: xCartHelper not registered, cart-add skipped');
      return;
    }

    buttonEl.disabled = true;
    await xCartHelper.waitForCartUpdate();
    window.updatingCart = true;

    try {
      var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: xCartHelper.getSectionsToRender().map(function (s) { return s.id; })
        })
      });
      var json = await response.json();

      if (response.status >= 400 || json.status === 422) {
        console.warn('OBB: cart-add rejected:', json.description || json.message || response.status);
        return;
      }

      xCartHelper.reRenderSections(json.sections);
      xCartHelper.currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    } catch (error) {
      console.error('OBB: cart-add network error:', error);
    } finally {
      window.updatingCart = false;
      buttonEl.disabled = false;
    }
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-obb-cart-upsell-add]');
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-obb-cart-upsell-add');
    if (!variantId) return;
    window.obbCartUpsellAdd(variantId, btn);
  });
})();
